'use strict';

import { PlayerState } from '@svt/videoplayer-types';
import { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import env from '../../../../../env';
import ContentoQuery, { ContentoData } from '../../../../Contento/ContentoQuery';
import EndScreenWithContinueWatchingContainer from './EndScreenWithContinueWatchingContainer.jsx';
import NextEpisodeContainer from './NextEpisodeContainer.jsx';
import PLAY_QUEUE_QUERY from './PlayQueue.graphql';
import BackButton from 'app/components/VideoPlayer/new/BackButton';
import { StyledContainer } from './EndScreen.styles';

function getNextVideo(videos, currentVisionId) {
    if (!videos) {
        return null;
    }

    // TODO Should select video based on access service preference
    const currentIndex = videos.findIndex((video) => video.item.id === currentVisionId);

    if (videos.length <= currentIndex + 1) {
        return null;
    }

    return videos[currentIndex + 1];
}

export class EndScreen extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isEndScreenVisible: false,
        };
    }

    componentDidUpdate(prevProps) {
        const prevStatePlayingOrEnded =
            prevProps.playerState === PlayerState.PLAYING ||
            prevProps.playerState === PlayerState.SEEKING ||
            prevProps.playerState === PlayerState.ENDED;

        /*
        When casting off, the casting dispatches an ENDED-state, which should not be considered as a 'valid' ENDED-state.
        */
        const validEndedTransition = prevStatePlayingOrEnded && this.props.playerState === PlayerState.ENDED;
        if (validEndedTransition) {
            if (this.props.nextVideoUrl && this.props.skipNextScreen) {
                this.onNextVideo(this.props.nextVideoUrl);
            } else {
                this.props.onDisplayEndScreen(true);
                this.setState({ isEndScreenVisible: true }); // eslint-disable-line react/no-did-update-set-state
            }
        } else if (this.state.isEndScreenVisible === true) {
            this.setState({ isEndScreenVisible: false }); // eslint-disable-line react/no-did-update-set-state
        } else if (this.state.isEndScreenVisible === false) {
            this.props.onDisplayEndScreen(false);
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return (
            nextProps.playerState !== this.props.playerState ||
            nextState.isEndScreenVisible !== this.state.isEndScreenVisible
        );
    }

    render() {
        if (!this.state.isEndScreenVisible) {
            return null;
        }

        const { escenicId, visionId, autoPlaySetting, isKidsGenre, currentVideoType } = this.props;

        return (
            <StyledContainer>
                <BackButton />
                <ContentoQuery
                    query={PLAY_QUEUE_QUERY}
                    variables={{
                        id: visionId,
                        includeFullOppetArkiv: env.FLAG_ENABLE_ALL_OA,
                    }}
                    fetchPolicy="cache-first"
                    ssr={false}
                >
                    <ContentoData>
                        {(data) => {
                            const nextVideo = getNextVideo(data?.playQueue?.flat, visionId);

                            const skipNextScreen =
                                currentVideoType === 'Clip' && nextVideo?.item.__typename === 'Clip';

                            if (nextVideo) {
                                return (
                                    <NextEpisodeContainer
                                        nextVideoTitle={nextVideo.name}
                                        nextVideoId={nextVideo.item.videoSvtId}
                                        nextVideoUrl={nextVideo.item.urls.svtplay}
                                        nextVideoPosterImageId={nextVideo.item.image.id}
                                        nextVideoPosterImageChanged={nextVideo.item.image.changed}
                                        nextVideoPosterImageAltText={nextVideo.item.image.description}
                                        autoPlaySetting={autoPlaySetting}
                                        skipNextScreen={skipNextScreen}
                                    />
                                );
                            }

                            return (
                                <EndScreenWithContinueWatchingContainer
                                    escenicId={escenicId}
                                    currentVideoId={visionId}
                                    isKidsGenre={isKidsGenre}
                                />
                            );
                        }}
                    </ContentoData>
                </ContentoQuery>
            </StyledContainer>
        );
    }
}

EndScreen.propTypes = {
    autoPlaySetting: PropTypes.bool,
    nextVideoTitle: PropTypes.string,
    skipNextScreen: PropTypes.bool,
    currentVideoType: PropTypes.string,
    nextVideoUrl: PropTypes.string,
    nextVideoPosterImageId: PropTypes.string,
    nextVideoPosterImageChanged: PropTypes.number,
    nextVideoPosterImageAltText: PropTypes.string,
    isKidsGenre: PropTypes.bool,
    visionId: PropTypes.string,
    escenicId: PropTypes.string,
    onDisplayEndScreen: PropTypes.func,
};

const EndScreenWithRouter = withRouter(EndScreen);

export default EndScreenWithRouter;
